import { render, staticRenderFns } from "./FormattedInputGenerico.vue?vue&type=template&id=27da6d1e&scoped=true"
import script from "./FormattedInputGenerico.vue?vue&type=script&lang=js"
export * from "./FormattedInputGenerico.vue?vue&type=script&lang=js"
import style0 from "./FormattedInputGenerico.vue?vue&type=style&index=0&id=27da6d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27da6d1e",
  null
  
)

export default component.exports